import React from "react";
import Skills from "../../Components/Skills/Skills.component";
import MainLayout from "../../styles/Layouts";
import Resume from "../../Components/Resume/Resume.component";

function ResumePage() {
  return (
    <MainLayout>
      <Skills />
      <Resume />
    </MainLayout>
  );
}

export default ResumePage;
